/* Prepared Chromium cart bridge. No effect without data-am-options-cart="true". */
(function (root) {
  'use strict';
  if (root.AMProductOptionsCart) { root.AMProductOptionsCart.mountAll(); return; }
  const controllers = new WeakMap(), mounted = new Set(), guarded = new WeakMap();
  let operation = null, locked = false;
  let refreshing = false;
  const rowsIn = node => [...node.querySelectorAll('.js-cart-item[data-key][data-am-options-group]')].filter(row => row.dataset.amOptionsGroup);
  const quantityInput = row => row.querySelector('.js-input-quantity,.js-qty');
  function localeRoot() {
    const prefix = root.Shopify?.routes?.root || '/';
    if (!/^\/(?!\/)[\w/\-]*$/.test(prefix)) throw new Error('Invalid Shopify locale route.');
    return prefix.replace(/\/?$/, '/');
  }
  function status(controller, text, error = false) {
    controller.status.textContent = text;
    controller.status.classList.toggle('am-option-error', error);
    controller.status.setAttribute('role', error ? 'alert' : 'status');
  }
  function guardControls() {
    for (const controller of mounted) {
      if (!controller.node.isConnected) { mounted.delete(controller); continue; }
      controller.node.setAttribute('aria-busy', String(Boolean(operation) || refreshing));
      for (const row of rowsIn(controller.node)) {
        const child = row.dataset.amOptionsRole === 'extra';
        for (const control of row.querySelectorAll('.js-qty-plus,.js-qty-minus,.js-btn-remove,.js-input-quantity,.js-qty')) {
          if (child) {
            if ('disabled' in control && !control.disabled && control.name && !control.nextElementSibling?.hasAttribute('data-am-options-preserve')) {
              const proxy = root.document.createElement('input'); proxy.type = 'hidden'; proxy.name = control.name; proxy.value = control.value;
              proxy.setAttribute('data-am-options-preserve', ''); control.after(proxy);
            }
            control.hidden = true;
          }
          if (child || operation || locked || refreshing) {
            if (!guarded.has(control)) guarded.set(control, { disabled: control.disabled, aria: control.getAttribute('aria-disabled') });
            control.setAttribute('aria-disabled', 'true');
            if ('disabled' in control) control.disabled = true;
          } else if (guarded.has(control)) {
            const original = guarded.get(control);
            if ('disabled' in control) control.disabled = original.disabled;
            if (original.aria === null) control.removeAttribute('aria-disabled'); else control.setAttribute('aria-disabled', original.aria);
            guarded.delete(control);
          }
        }
      }
    }
  }
  function findController(row) { const node = row?.closest('[data-am-options-cart="true"]'); return node && controllers.get(node); }
  function findRow(target) { return target?.closest?.('.js-cart-item[data-key][data-am-options-group]'); }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  async function readCart(timeout) {
    const abort = new root.AbortController(); let timer;
    try {
      return await Promise.race([
        (async () => {
        const response = await root.fetch(localeRoot() + 'cart.js', { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: abort.signal });
        if (!response.ok) throw new Error('The current cart could not be read.');
        return await response.json();
        })(),
        new Promise((resolve, reject) => { timer = root.setTimeout(() => { abort.abort(); reject(new Error('Cart request timed out.')); }, timeout); }),
      ]);
    } finally { root.clearTimeout(timer); }
  }
  async function changeGroups(controller, changes) {
    if (operation || locked || refreshing) return;
    if (!root.AMProductOptionsStorefront?.updateGroup) {
      locked = true; status(controller, 'Cart option scripts are missing. Refresh the cart before continuing.', true); guardControls(); return;
    }
    operation = { controller }; guardControls(); status(controller, 'Updating the product and its extras…');
    try {
      let cart = await readCart(controller.timeout);
      for (const change of changes) cart = await root.AMProductOptionsStorefront.updateGroup(cart, change.groupId, change.quantity, { timeout: controller.timeout });
      // Keep all group controls and checkout locked until the fresh server page replaces this UI.
      locked = true;
      status(controller, 'Cart updated. Refreshing the cart…');
      controller.navigate(localeRoot() + 'cart');
    } catch (error) {
      locked = true;
      status(controller, 'We could not confirm the complete cart update. Refresh and inspect your cart before continuing. This change will not be retried.', true);
      const link = root.document.createElement('a'); link.href = localeRoot() + 'cart'; link.textContent = ' Refresh cart'; controller.status.append(link);
    } finally { operation = null; guardControls(); }
  }
  function requestedQuantity(controller, row, quantity) {
    if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > (root.AMProductOptions?.MAX_QUANTITY || 9999)) {
      status(controller, 'Enter a whole quantity between 1 and 9999.', true);
      const input = quantityInput(row); if (input) input.value = row.dataset.amOptionsQuantity || '1';
      return;
    }
    void changeGroups(controller, [{ groupId: row.dataset.amOptionsGroup, quantity }]);
  }
  function mount(node, options = {}) {
    if (!node || node.dataset.amOptionsCart !== 'true') return null;
    if (controllers.has(node)) return controllers.get(node);
    const notice = node.querySelector('[data-am-options-cart-status]') || node.insertBefore(root.document.createElement('p'), node.firstChild);
    notice.setAttribute('data-am-options-cart-status', ''); notice.setAttribute('aria-live', 'polite');
    const controller = { node, status: notice, timeout: options.timeout || 15000, navigate: options.navigate || (url => root.location.assign(url)) };
    controllers.set(node, controller); mounted.add(controller);
    guardControls();
    return controller;
  }
  function mountAll() { if (!root.document?.documentElement) return; root.document.querySelectorAll('[data-am-options-cart="true"]').forEach(node => mount(node)); guardControls(); }
  root.addEventListener('click', event => {
    const row = findRow(event.target), controller = findController(row);
    if (!controller || !row) return;
    const control = event.target.closest('.js-qty-plus,.js-qty-minus,.js-btn-remove');
    if (!control || !row.contains(control)) return;
    stop(event);
    if (row.dataset.amOptionsRole !== 'base' || operation || locked || refreshing) return;
    if (control.classList.contains('js-btn-remove')) { requestedQuantity(controller, row, 0); return; }
    const input = quantityInput(row), previous = Number(input?.value);
    const next = control.classList.contains('js-qty-plus') ? previous + 1 : Math.max(1, previous - 1);
    if (next === previous) return;
    if (input) input.value = String(next);
    requestedQuantity(controller, row, next);
  }, true);
  root.addEventListener('change', event => {
    const row = findRow(event.target), controller = findController(row);
    if (!controller || !event.target.matches('.js-input-quantity,.js-qty')) return;
    stop(event);
    if (row.dataset.amOptionsRole !== 'base' || operation || locked || refreshing) return;
    const quantity = Number(event.target.value);
    if (quantity < 1) { status(controller, 'Use Remove to remove this product and its extras.', true); event.target.value = row.dataset.amOptionsQuantity || '1'; return; }
    requestedQuantity(controller, row, quantity);
  }, true);
  root.addEventListener('submit', event => {
    const form = event.target;
    const associated = [...mounted].filter(controller => form.contains(controller.node) || controller.node.contains(form));
    if (!associated.length) return;
    if (operation || locked || refreshing) {
      stop(event);
      status(operation?.controller || associated[0], operation || refreshing ? 'Wait for the product and extras to finish updating before checkout.' : 'Refresh and inspect your cart before continuing.', true);
      return;
    }
    // Capture an unblurred manual edit before checkout/update can submit a mismatched parent quantity.
    const changes = associated.flatMap(controller => rowsIn(controller.node).filter(row => row.dataset.amOptionsRole === 'base').flatMap(row => {
      const input = quantityInput(row), quantity = Number(input?.value), initial = Number(row.dataset.amOptionsQuantity);
      return input && quantity !== initial ? [{ controller, row, groupId: row.dataset.amOptionsGroup, quantity }] : [];
    }));
    if (!changes.length) return; // Normal idle checkout, notes and unrelated updates remain native.
    stop(event);
    if (changes.some(change => !Number.isSafeInteger(change.quantity) || change.quantity < 1 || change.quantity > 9999)) {
      status(associated[0], 'Enter valid whole product quantities before checkout.', true); return;
    }
    void changeGroups(associated[0], changes);
  }, true);
  root.document.addEventListener('am:product-options-added', event => {
    const cart = event.detail?.cart, themeCart = root.Cart;
    if (!cart || !Array.isArray(cart.items) || !themeCart || refreshing) return;
    // Chromium's ordinary add callback accepts one line and cannot render a whole
    // parent/extra group. Replace cached views from Liquid instead of cloning it.
    themeCart.value = cart;
    root.document.querySelectorAll('.js-cart-items-count').forEach(node => { node.textContent = String(cart.item_count ?? cart.items.reduce((sum, item) => sum + item.quantity, 0)); });
    if (Number.isSafeInteger(cart.total_price)) {
      root.document.querySelectorAll('.js-cart-icon-total-money').forEach(node => {
        if (root.Currencies) node.setAttribute('data-money', String(cart.total_price));
        else node.textContent = root.AMProductOptions.money(cart.total_price, cart.currency || 'CAD');
      });
    }
    root.document.querySelectorAll('.js-cart-icon-container,#cart-drawer-container').forEach(node => { node.dataset.items = String(cart.item_count ?? cart.items.reduce((sum, item) => sum + item.quantity, 0)); });
    const loads = [];
    if (themeCart.drawerLoaded && themeCart.drawer?.load) loads.push(() => themeCart.drawer.load());
    if (themeCart.dropdownLoaded && themeCart.loadDropdown) loads.push(() => themeCart.loadDropdown());
    if (!loads.length) return; // The theme lazily loads untouched drawers from Shopify.
    refreshing = true; guardControls(); let timer;
    void Promise.race([
      Promise.all(loads.map(load => Promise.resolve().then(load))),
      new Promise((resolve, reject) => { timer = root.setTimeout(() => reject(new Error('Cart view refresh timed out.')), 15000); }),
    ]).then(() => {
      root.clearTimeout(timer); refreshing = false; mountAll();
    }).catch(() => {
      root.clearTimeout(timer); refreshing = false; locked = true; guardControls();
      for (const controller of mounted) status(controller, 'Your items were added. Refresh your cart to load the current product and extras before checkout.', true);
    });
  });
  root.AMProductOptionsCart = Object.freeze({ mount, mountAll });
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', mountAll, { once: true }); else mountAll();
  // The Chromium drawer inserts server-rendered rows after the page has loaded.
  new root.MutationObserver(() => mountAll()).observe(root.document.documentElement, { childList: true, subtree: true });
}(window));
